import React from 'react'

const SettingsPageLayout = () => {
  return (
    <div>
      <h1>SettingsPageLayout</h1>
    </div>
  )
}

export default SettingsPageLayout
